export const httpCode = {
  CONTINUE: 100, // CONTINUE
  PROCESSING: 102, // Processing
  OK: 200, // OK
  CREATED: 201, // Created
  ACCEPTED: 202, // Accepted
  NO_CONTENT: 204, // No Content
  TEMPORARY_REDIRECT: 307, // Temporary Redirect
  PERMANENT_REDIRECT: 308, // Permanent Redirect
  NOT_MODIFIED: 304, // Not Modified
  BAD_REQUEST: 400, // Bad Request
  UNAUTHORIZED: 401, // Unauthorized
  PAYMENT_REQUIRED: 402, // Payment Required
  FORBIDDEN: 403, // Forbidden
  NOT_FOUND: 404, // Not Found
  METHOD_NOT_ALLOWED: 405, // Method Not Allowed
  NOT_ACCEPTABLE: 406, // Not Acceptable
  REQUEST_TIMEOUT: 408, // Request Timeout
  CONFLICT: 409, // Conflict
  REQUEST_TOO_LONG: 413, // Request Entity Too Large
  REQUEST_URI_TOO_LONG: 414, // Request - URI Too Long
  UNSUPPORTED_MEDIA_TYPE: 415, // Unsupported Media Type
  LOCKED: 423, // Locked
  TOO_MANY_REQUESTS: 429, // Too Many Requests
  INTERNAL_SERVER_ERROR: 500, // Internal Server Error
  SERVICE_UNAVAILABLE: 503, // Service Unavailable
  CLOSED: 499,
  MOVED_PERMANENTLY: 301,
};

export default httpCode;
